module.exports = __webpack_public_path__ + "static/statistics_img@3x.844ba2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/statistics_img@3x.png
// module id = 229
// module chunks = 193162123475590 216210090109534